/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAppLearningResp } from 'generated-types';
import { AlbHttpClient } from 'ng/modules/http/service/alb-http-client.service';

const APP_INSIGHTS_URL = '/api/analytics/learning/virtualservice';

/**
 * @description Service for App Insights.
 * @author alextsg
 */
@Injectable({
    providedIn: 'root',
})
export class AppInsightsService {
    constructor(private readonly http: AlbHttpClient) {}

    /**
     * Fetch app insights data for the Virtual Service and WAF Policy.
     */
    public fetchAppInsightsData(vsId: string): Observable<IAppLearningResp> {
        const params = {
            app_id: vsId,
            stats: true,
            confidence: 'certain',
        };

        return this.http.get<IAppLearningResp>(APP_INSIGHTS_URL, { params });
    }
}
